<script>
    export let title;
</script>

<h2>{title}</h2>